module.exports = __webpack_public_path__ + "img/map_Z1.3.B.02.c1de0210.svg";